import { render, staticRenderFns } from "./WebupList.vue?vue&type=template&id=51dbcc18&scoped=true&"
import script from "./WebupList.vue?vue&type=script&lang=ts&"
export * from "./WebupList.vue?vue&type=script&lang=ts&"
import style0 from "./WebupList.vue?vue&type=style&index=0&id=51dbcc18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51dbcc18",
  null
  
)

export default component.exports